export default __webpack_public_path__ + "static/komitet-do-spraw-pozytku-publicznego-4a94afea1200c5e5a6951aefca12b2a4.jpg";